import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { agentLoginService } from "../Services/Service";

const AgentLoginForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const result = await agentLoginService(email, password);

      if (result?.token) {

        localStorage.setItem("AgentUsername", email);
        localStorage.setItem("AgentPassword", password);
        localStorage.setItem("AgentAuthToken", result.token);
        localStorage.setItem("authType", "agent");
        // console.log("token",result.token)

        navigate("/Agent/Booking");
      } else {
        setError("Invalid login credentials");
      }
    } catch (err) {
      setError("Something went wrong. Try again.");
      console.error("Login error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <div className="fullscreen-loader">
          <div className="fas fa-spinner fa-spin fa-3x" role="status"></div>
        </div>
      )}
      <div className="login-wrapper d-flex">
        {/* Left Panel */}
        <div className="login-left ">

          <h2 className="fw-bold ">Welcome back!</h2>
          <p className="text-muted mb-1 ">User Experience & Interface Design</p>
          <p className="text-muted ">Strategy SaaS Solutions</p>
          <img
            src="https://cdni.iconscout.com/illustration/premium/thumb/login-3305943-2757111.png"
            alt="login"
            className="img-fluid mt-5 "
            style={{ maxWidth: '220px' }}
          />
        </div>

        {/* Right Panel */}
        <div className="login-right">
          <div className="login-box w-100">
            <h3 className="text-center fw-bold mb-4">Sign in your Agent account</h3>
            <form onSubmit={handleLogin}>
              <div className="mb-3">
                <label className="form-label">Username/Email</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter your username"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Password</label>
                <input
                  type="password"
                  className="form-control"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>

              <div className="text-end mb-3">
                <Link to="/Forgotpassword" className="text-primary">
                  Forgot password?
                </Link>
              </div>

              {error && <div className="text-danger text-center mb-2">{error}</div>}

              <button type="submit" className="btn btn-primary w-100 fw-bold">
                Sign In
              </button>
            </form>

          </div>
        </div>
      </div>
    </>
  );
}

export default AgentLoginForm;




